module.exports = __webpack_public_path__ + "static/media/appStore.2b11a9ed.svg";